import React, { useState } from 'react';
import Context from './index';

const GalleryProvider = (props) => {
    const [images] = useState([]);
    const [smallImages] = useState([]);
    const [masonryImg] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                images,
                smallImages,
                masonryImg
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default GalleryProvider;